const review = {
  initialize() {
    $('body').on('click', '.js-review-response', ({ currentTarget }) => {
      this.openForm(currentTarget);
    });
  },

  openForm(target) {
    $(target).parent().find('.js-review-response-form').show();
  },
};

export default review;
